import {MimeType} from '@coolcolduk/enum';
import {Dropzone} from '@coolcolduk/ui-mui';
import {Box, Button, TextField} from '@mui/material';
import {usePDF} from '@react-pdf/renderer';
import {useEffect, useState} from 'react';
import {parseCsvWithPapa} from '../../../util/papa/parseCsvWithPapa';
import FlashCardPdf from './FlashCardPdf';

export default function FlashCard() {
  const [csvData, setCSVData] = useState<string[][]>([]);
  const [title, setTitle] = useState('');

  const [pdf, updatePdf] = usePDF({
    document: <FlashCardPdf title={title} csvData={csvData} />,
  });

  useEffect(() => {
    updatePdf(<FlashCardPdf title={title} csvData={csvData} />);
  }, [csvData, updatePdf, title]);

  const handleFileUpload = async (files: File[]) => {
    const file = files[0];
    const result = await parseCsvWithPapa<string[]>(file, {header: false});
    setCSVData(result.data);
  };

  const handleDownload = () => {
    if (pdf.url) {
      const link = document.createElement('a');
      link.href = pdf.url;
      link.download = 'flashcards.pdf';
      link.click();
    }
  };

  return (
    <Box sx={{p: 4}}>
      <TextField
        fullWidth
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        placeholder="Enter title"
        sx={{mb: 2}}
      />
      <Dropzone
        files={[]}
        setFiles={handleFileUpload}
        acceptedFileTypes={[MimeType.TEXT_CSV, MimeType.APPLICATION_VND_MS_EXCEL]}
      />
      {csvData.length > 0 && (
        <Box sx={{mt: 2}}>
          <Button variant="contained" color="primary" onClick={handleDownload} disabled={pdf.loading}>
            {pdf.loading ? 'Generating PDF...' : 'Download Flashcards PDF'}
          </Button>
        </Box>
      )}
    </Box>
  );
}
